<script lang="ts">
	import RangePresets from "@hitit/hub/src/v7/components/common/RangePresets.svelte";
	import DateRange from "@hitit/hub/src/v7/components/common/DateRange.svelte";
	import SalesIncomes from "../components/dashboard/SalesIncomes.svelte";
	import Pecktime from "../components/dashboard/Pecktime.svelte";
	import DiscountRedeemdTrend from "../components/dashboard/DiscountRedeemdTrend.svelte";
	import SalesChart from "../components/dashboard/SalesChart.svelte";
	import SalesItemRanking from "../components/dashboard/SalesItemRanking.svelte";
	import VisitTrend from "../components/dashboard/VisitTrend.svelte";
	import EarnedTrend from "../components/dashboard/EarnedTrend.svelte";
	import RedeemedTrend from "../components/dashboard/RedeemedTrend.svelte";
	import { Card } from "@hitit/new_ui/src";
	import { endOfDay, startOfDay } from "date-fns";
	import { api } from "../../stores";
	import { onDestroy } from "svelte";
	import { popup } from "../store";
	type RangeHandlerEvent = { detail: { start: Date; end: Date } };
	export let storeIds: string[] = [];
	export let today = startOfDay(new Date());
	export let range = {
		start: startOfDay(new Date()),
		end: endOfDay(new Date()),
	};
	let hasPointSetting = false;

	function rangeHandler(e: RangeHandlerEvent) {
		const { start, end } = e.detail;
		range = { start, end: endOfDay(end) };
	}

	function getPointSetting(storeId: string) {
		return $api.getPointSetting(storeId);
	}

	$: (async (__storeIds: string[]) => {
		try {
			const origins = __storeIds;
			const pointSettings = __storeIds.map((v) => getPointSetting(v));
			const responses = await Promise.all(pointSettings);
			if (__storeIds.join("|") !== origins.join("|")) {
				return;
			}

			hasPointSetting = responses.reduce((prev, cur) => {
				if (prev) return true;
				return cur.data.setting.pointType === "POINT";
			}, false);
		} catch (e) {}
	})(storeIds);

	onDestroy(() => {
		$popup = undefined;
	});

</script>

<div class="container">
	<SalesIncomes storeIds={storeIds} today={today} />
	<div class="date-range-container">
		<RangePresets today={today} range={range} on:change={rangeHandler} />
		<DateRange range={range} on:change={rangeHandler} />
	</div>
	<div class="chart-container same-width sales-discount">
		<div class="chart-box">
			<Card noPadding>
				<SalesChart range={range} storeIds={storeIds} />
			</Card>
		</div>
		<div class="chart-box">
			<Card noPadding>
				<DiscountRedeemdTrend range={range} storeIds={storeIds} />
			</Card>
		</div>
	</div>
	<div class="chart-container same-width pick-item">
		<div class="chart-box picktime">
			<Card noPadding>
				<Pecktime range={range} storeIds={storeIds} />
			</Card>
		</div>
		<div class="chart-box ranking">
			<Card noPadding>
				<SalesItemRanking range={range} storeIds={storeIds} />
			</Card>
		</div>
	</div>
	{#if hasPointSetting}
		<div class="chart-container point">
			<div class="chart-box visit-trend">
				<Card noPadding>
					<VisitTrend range={range} storeIds={storeIds} />
				</Card>
			</div>
			<div class="chart-box point-trend">
				<Card noPadding>
					<EarnedTrend range={range} storeIds={storeIds} />
				</Card>
			</div>
			<div class="chart-box point-trend">
				<Card noPadding>
					<RedeemedTrend range={range} storeIds={storeIds} />
				</Card>
			</div>
		</div>
	{/if}
</div>

<style lang="scss">
	@import "../../variables.scss";

	.container {
		width: 100%;
		display: flex;
		flex-direction: column;
		gap: 20px;
		padding-top: 50px;

		.date-range-container {
			display: flex;
			flex-wrap: wrap;
			gap: 12px;
		}

		.chart-container {
			width: 100%;
			display: flex;
			flex-direction: column;
			gap: 10px;
			&.sales-discount {
				.chart-box {
					height: 505px;
				}
			}
			&.pick-item {
				.picktime {
					height: 640px;
				}
				.ranking {
					height: 918px;
				}
			}

			&.same-width {
				.chart-box {
					width: 100%;
				}
			}

			&.point {
				.chart-box {
					width: 100%;
				}

				.visit-trend {
					height: 412px;
				}
				.point-trend {
					height: 426px;
				}
			}
		}
	}

	@include DesktopSize {
		.container {
			gap: 30px;
			padding-top: 0;

			.chart-container {
				flex-direction: row;
				gap: 20px;
				&.saels-discount {
					.chart-box {
						height: 600px;
					}
				}
				&.pick-item {
					.picktime {
						height: 960px;
					}
					.ranking {
						height: 960px;
					}
				}

				&.same-width {
					.chart-box {
						width: calc(50% - 10px);
					}
				}
				&.point {
					.visit-trend {
						min-width: 200px;
						max-width: 300px;
						width: max-content;
						height: 498px;
						flex-basis: calc(100% * (298 / 1558));
						flex-grow: 298;
					}
					.point-trend {
						width: max-content;
						height: 498px;
						flex-basis: calc(100% * (628 / 1558));
						flex-grow: 628;
					}
				}
			}
		}
	}

</style>
